import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedComponentsModule } from '../shared/shared.module';
import { RegisterComponent } from './register.component';

const routes: Routes = [
  { path: '', component: RegisterComponent }
];

@NgModule({
  declarations:  [
    RegisterComponent
  ],
  imports: [
    SharedComponentsModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class RegisterComponentModule { }
